/**
 * MDI icon names for domaines and competences (Material Design Icons).
 * Used in the map left panel for visual identification.
 */

const DOMAINE_ICONS: Record<string, string> = {
  ENV_RN: 'mdi:leaf',
  DEFAULT: 'mdi:folder-outline',
}

/** Keywords in cptLib (lowercase) mapped to MDI icon name */
const COMPETENCE_ICON_KEYWORDS: { keywords: string[]; icon: string }[] = [
  { keywords: ['eau', 'eau potable', 'alimentation en eau'], icon: 'mdi:water-pump' },
  { keywords: ['ordures', 'déchets', 'enlèvement', 'collecte'], icon: 'mdi:trash-can-outline' },
  { keywords: ['pré-collecte', 'pre-collecte'], icon: 'mdi:recycle' },
  { keywords: ['assainissement', 'eaux usées'], icon: 'mdi:pipe' },
  { keywords: ['voirie', 'routes'], icon: 'mdi:road' },
  { keywords: ['éclairage', 'électricité'], icon: 'mdi:lightbulb-outline' },
  { keywords: ['santé', 'hygiène'], icon: 'mdi:medical-bag' },
  { keywords: ['éducation', 'école'], icon: 'mdi:school-outline' },
  { keywords: ['urbanisme', 'construction'], icon: 'mdi:domain' },
  { keywords: ['environnement', 'ressources naturelles'], icon: 'mdi:leaf' },
]

const COMPETENCE_DEFAULT_ICON = 'mdi:format-list-bulleted'

export function getDomaineIcon(domaineCode: string): string {
  return DOMAINE_ICONS[domaineCode] ?? DOMAINE_ICONS.DEFAULT
}

export function getCompetenceIcon(cptLib: string): string {
  const lower = cptLib.toLowerCase()
  for (const { keywords, icon } of COMPETENCE_ICON_KEYWORDS) {
    if (keywords.some((k) => lower.includes(k))) {
      return icon
    }
  }
  return COMPETENCE_DEFAULT_ICON
}

/** Indicator icon: % (rate/percent), area (zone), or marker (point). */
const INDICATEUR_ICON_KEYWORDS: { keywords: string[]; icon: string }[] = [
  { keywords: ['taux', 'pourc', 'pourcentage', '%', 'ratio', 'complétude'], icon: 'mdi:percent' },
  {
    keywords: ['zone', 'secteur', 'area', 'carroyage', 'densité', 'buffer', 'aire'],
    icon: 'mdi:map-marker-radius',
  },
]

const INDICATEUR_DEFAULT_ICON = 'mdi:map-marker'

export function getIndicateurIcon(atgTitre: string): string {
  const lower = atgTitre.toLowerCase()
  for (const { keywords, icon } of INDICATEUR_ICON_KEYWORDS) {
    if (keywords.some((k) => lower.includes(k))) {
      return icon
    }
  }
  return INDICATEUR_DEFAULT_ICON
}
